//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SketchOperationBuilder.js";
import "../no/Sketch.js";
import "../no/ugmath.js";
let d=[[[0,"SnapEnabled",1,0],[0,"SnapGeometry",1,0],[0,"SnapRadius",1,0],[0,"SnapToGridOffset",1,0],[0,"SplineLinearScale",1,0]],[[["numDragObjects","dragObjects"],"GetDragGeometry",{},0,0],[["dragObjects"],"SetDragGeometry",{},1,0],[["initialPosition"],"InitializeDrag",{},1,0],[["snapTarget"],"SetSnapTarget",{},1,0],[["snapTarget","snapHelpPoint"],"SetSnapPointTarget",{},2,0],[["newPosition"],"DragToPoint",{},1,0],[[],"DetachGeometry",{},0,0],[["anySolveSuccessful","inputPoint"],"GetLastSuccessfulSolve",{},0,0]],[]];
SPLM.SketchDragGeometryBuilder = class extends SPLM.SketchOperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchDragGeometryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;